import React, { ReactElement, useContext, useMemo } from 'react';
import { node, object } from 'prop-types';
import { useImpressionContainer, useImpressionItem } from '@fiverr-private/impressionable';
import { Impression_Component } from '@fiverr-private/bianka_js';
import type { GigListingsProps } from '../../types';
import { EventReportingManagerContext } from '../../../../../../components/EventReportingManager';
import { getListingsImpressionEnrichment, onListingsContainerImpression } from './utils';

const ListingsImpressionContainer = ({
    listingsProps,
    children,
}: {
    listingsProps: GigListingsProps;
    children: ReactElement;
}) => {
    const { enabled: reportingEnabled } = useContext(EventReportingManagerContext);
    const listingsImpressionEnrichment = useMemo(() => getListingsImpressionEnrichment(listingsProps), [listingsProps]);

    const [containerRef, containerId] = useImpressionContainer();
    useImpressionItem({
        selfRef: containerRef,
        selfId: containerId,
        enrichment: listingsImpressionEnrichment,
        sendImpressionToBQ: false,
        intersectionThreshold: 0,
        onImpression: (impressionData: Impression_Component) =>
            reportingEnabled && onListingsContainerImpression(impressionData, listingsProps),
    });

    if (!children) {
        return null;
    }

    return <div ref={containerRef}>{children}</div>;
};

ListingsImpressionContainer.propTypes = {
    listingsProps: object.isRequired,
    children: node.isRequired,
};

export default ListingsImpressionContainer;
